import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { WIDGET_CONFIGS } from '../edit/widget/_configs'
import { useIntegrations } from './_load/IntegrationsLoader'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useOpenTriggersTemplatesModal } from '../../../utils/routes/modals/modalsActions'
import BigCardPicker from '../../../packages/kiti/components/form/BigCardPicker'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Text, { SmallText } from '../../../packages/kiti/components/presentation/Text'

const WidgetPicker = props => {
  return <BigCardPicker {...props} options={WIDGET_CONFIGS} />
}

const IntegrationsList = props => {
  const { t } = useTranslation('listIntegrations')
  const integrations = useIntegrations()
  const data = useModalData()
  const openNewTriggerModal = useOpenTriggersTemplatesModal()

  const handleSelect = value => {
    openNewTriggerModal({ integrationId: value.id, ...data })
  }

  return (
    <Grid direction="column" align="stretch" justify="center" gap={0.6}>
      {integrations.map(item => (
        <Panel direction="row" key={item.id} align="center" onClick={() => handleSelect(item)}>
          <Col flex={1}>
            <Text bold aling="center">
              {item.name}
            </Text>
            <SmallText aling="center">{item.createdBy?.name}</SmallText>
          </Col>

          <Col>
            <IconText
              iconRight="RiArrowRightCircleLine"
              label={t('select')}
              color="primary"
              size="h6"
              bold
              iconSize={1.2}
            />
          </Col>
        </Panel>
      ))}
    </Grid>
  )
}

export default IntegrationsList
